/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Link, Outlet, Route, Routes} from 'react-router-dom'
import {ForgotPassword} from './components/ForgotPassword'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {LoginPage} from './components/LoginPage'
import {SsoPage} from './components/SsoPage'

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('auth-bg')
    return () => {
      document.body.classList.remove('auth-bg')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid min-vh-100'
      style={{
        background: 'radial-gradient(ellipse at 60% 20%, #1a2744 0%, #0d1117 40%, #080a10 100%)',
      }}
    >
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* Logo */}
        <Link to='/auth' className='mb-10'>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/logo-main.png')}
            style={{height: '44px'}}
          />
        </Link>

        {/* Card */}
        <div
          className='mx-auto w-100 p-10 p-lg-12'
          style={{
            maxWidth: '480px',
            background: '#111827',
            border: '1px solid #1e2a3d',
            borderRadius: '16px',
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<LoginPage />} />
      <Route path='sso' element={<SsoPage />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route index element={<LoginPage />} />
    </Route>
  </Routes>
)

export {AuthPage}
